var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"token",class:_vm.classes,attrs:{"data-index":_vm.value.index}},[_c('span',{class:_vm.classes,domProps:{"innerHTML":_vm._s(_vm.value.text.replace(/\n/g, '<br>'))}}),_vm._v(_vm._s(_vm.value.delimiter))])}
var staticRenderFns = []

export { render, staticRenderFns }